module.exports = __webpack_public_path__ + "static/media/arrow-down.31e4bba8.svg";